import { ArrowRight, Zap } from "lucide-react";
import { DemoHint } from "@/components/demo/DemoHint";

export default function DirectPostHeader() {
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-card border-b border-border">
      <div className="flex items-center gap-2.5">
        <Zap className="h-4.5 w-4.5" style={{ color: "hsl(var(--brand-teal-deep))" }} />
        <DemoHint hintKey="page.lrDirectPost" side="bottom" showIndicator>
          <h2 className="text-base font-semibold tracking-wide uppercase text-foreground">
            LR Direct
          </h2>
        </DemoHint>
        <ArrowRight className="h-3.5 w-3.5 text-muted-foreground" />
        <span className="text-sm text-muted-foreground font-medium">Post Load</span>
      </div>
      <div className="flex items-center gap-3 text-xs">
        <span className="text-muted-foreground">
          <span className="text-destructive font-semibold">*</span> Required fields to post.
        </span>
      </div>
    </div>
  );
}
